@if (waybillPayload) {
  <div>
    <mat-accordion [@.disabled]="disableAnimation">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Pickup point
          </mat-panel-title>
          <mat-panel-description>
            Dawn wing will collect the package here
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="details">
          <table>
            <tr>
              <th>Waybill number</th>
              <td>{{waybillPayload.waybillNo ? waybillPayload.waybillNo : "-"}}</td>
            </tr>
            <tr>
              <th>Account number</th>
              <td>{{waybillPayload.sendAccNo ? waybillPayload.sendAccNo : '-'}}</td>
            </tr>
            <tr>
              <th>Site</th>
              <td>{{waybillPayload.sendSite ? waybillPayload.sendSite : '-'}}</td>
            </tr>
            <tr>
              <th>Company</th>
              <td>{{waybillPayload.sendCompany ? waybillPayload.sendCompany : '-'}}</td>
            </tr>
            <tr>
              <th>Unit</th>
              <td>{{waybillPayload.sendAdd1 ? waybillPayload.sendAdd1 : '-'}}</td>
            </tr>
            <tr>
              <th>Street</th>
              <td>{{waybillPayload.sendAdd2 ? waybillPayload.sendAdd2 : '-'}}</td>
            </tr>
            <tr>
              <th>City</th>
              <td>{{waybillPayload.sendAdd3 ? waybillPayload.sendAdd3 : '-'}}</td>
            </tr>
            <tr>
              <th>Suburb</th>
              <td>{{waybillPayload.sendAdd4 ? waybillPayload.sendAdd4 : '-'}}</td>
            </tr>
            <tr>
              <th>Post code</th>
              <td>{{waybillPayload.sendAdd5 ? waybillPayload.sendAdd5 : '-'}}</td>
            </tr>
            <tr>
              <th>Building number</th>
              <td>{{waybillPayload.sendAdd6 ? waybillPayload.sendAdd6 : '-'}}</td>
            </tr>
            <tr>
              <th>Building name</th>
              <td>{{waybillPayload.sendAdd7 ? waybillPayload.sendAdd7 : '-'}}</td>
            </tr>
            <tr>
              <th>Longitude</th>
              <td>{{waybillPayload.sendLongitude ? waybillPayload.sendLongitude : '-'}}</td>
            </tr>
            <tr>
              <th>Latitude</th>
              <td>{{waybillPayload.sendLatitude ? waybillPayload.sendLatitude : '-'}}</td>
            </tr>
            <tr>
              <th>what3words address</th>
              <td>{{waybillPayload.sendW3w ? waybillPayload.sendW3w : '-'}}</td>
            </tr>
            <tr>
              <th>Contact person</th>
              <td>{{waybillPayload.sendContactPerson ? waybillPayload.sendContactPerson : '-'}}</td>
            </tr>
            <tr>
              <th>Home tel</th>
              <td>{{waybillPayload.sendHomeTel ? waybillPayload.sendHomeTel : '-'}}</td>
            </tr>
            <tr>
              <th>Work tel</th>
              <td>{{waybillPayload.sendWorkTel ? waybillPayload.sendWorkTel : '-'}}</td>
            </tr>
            <tr>
              <th>Cell</th>
              <td>{{waybillPayload.sendCell ? waybillPayload.sendCell : '-'}}</td>
            </tr>
          </table>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Drop off point
          </mat-panel-title>
          <mat-panel-description>
            Dawnwing will drop off the package here
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="details">
          <table>
            <tr>
              <th>Company</th>
              <td>{{waybillPayload.recCompany ? waybillPayload.recCompany : '-'}}</td>
            </tr>
            <tr>
              <th>Email address</th>
              <td>{{waybillPayload.recEmailAddress ? waybillPayload.recEmailAddress : '-'}}</td>
            </tr>
            <tr>
              <th>Unit</th>
              <td>{{waybillPayload.recAdd1 ? waybillPayload.recAdd1 : '-'}}</td>
            </tr>
            <tr>
              <th>Street</th>
              <td>{{waybillPayload.recAdd2 ? waybillPayload.recAdd2 : '-'}}</td>
            </tr>
            <tr>
              <th>City</th>
              <td>{{waybillPayload.recAdd3 ? waybillPayload.recAdd3 : '-'}}</td>
            </tr>
            <tr>
              <th>Suburb</th>
              <td>{{waybillPayload.recAdd4 ? waybillPayload.recAdd4 : '-'}}</td>
            </tr>
            <tr>
              <th>Post code</th>
              <td>{{waybillPayload.recAdd5 ? waybillPayload.recAdd5 : '-'}}</td>
            </tr>
            <tr>
              <th>Building number</th>
              <td>{{waybillPayload.recAdd6 ? waybillPayload.recAdd6 : '-'}}</td>
            </tr>
            <tr>
              <th>Building name</th>
              <td>{{waybillPayload.recAdd7 ? waybillPayload.recAdd7 : '-'}}</td>
            </tr>
            <tr>
              <th>Longitude</th>
              <td>{{waybillPayload.recLongitude ? waybillPayload.recLongitude : '-'}}</td>
            </tr>
            <tr>
              <th>Latitude</th>
              <td>{{waybillPayload.recLatitude ? waybillPayload.recLatitude : '-'}}</td>
            </tr>
            <tr>
              <th>What3words address</th>
              <td>{{waybillPayload.recW3w ? waybillPayload.recW3w : '-'}}</td>
            </tr>
            <tr>
              <th>Contact person</th>
              <td>{{waybillPayload.recContactPerson ? waybillPayload.recContactPerson : '-'}}</td>
            </tr>
            <tr>
              <th>Home tel</th>
              <td>{{waybillPayload.recHomeTel ? waybillPayload.recHomeTel : '-'}}</td>
            </tr>
            <tr>
              <th>Work tel</th>
              <td>{{waybillPayload.recWorkTel ? waybillPayload.recWorkTel : '-'}}</td>
            </tr>
            <tr>
              <th>Cell</th>
              <td>{{waybillPayload.recCell ? waybillPayload.recCell : '-'}}</td>
            </tr>
          </table>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Waybill information
          </mat-panel-title>
          <mat-panel-description>
            General waybill information
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="details">
          <table>
            <tr>
              <th>Waybill Number</th>
              <td>{{waybillPayload.waybillNo ? waybillPayload.waybillNo : '-'}}</td>
            </tr>
            <tr>
              <th>Special instructions</th>
              <td>{{waybillPayload.specialInstructions ? waybillPayload.specialInstructions : '-'}}</td>
            </tr>
            <tr>
              <th>Service type</th>
              <td>{{serviceType ? serviceType : '-'}}</td>
            </tr>
            <tr>
              <th>Total quantity</th>
              <td>{{totalQuantity ? totalQuantity : '-'}}</td>
            </tr>
            <tr>
              <th>Total mass</th>
              <td>{{totalMass ? totalMass : '-'}}</td>
            </tr>
            <tr>
              <th>Insured</th>
              <td>{{isInsured ? isInsured : '-'}}</td>
            </tr>
            <tr>
              <th>Insurance value</th>
              <td>{{waybillPayload.insuranceValue ? waybillPayload.insuranceValue : '-'}}</td>
            </tr>
            <tr>
              <th>Customer reference</th>
              <td>{{waybillPayload.customerRef ? waybillPayload.customerRef : '-'}}</td>
            </tr>
            <tr>
              <th>Store code</th>
              <td>{{waybillPayload.storeCode ? waybillPayload.storeCode : '-'}}</td>
            </tr>
            <tr>
              <th>Security stamp</th>
              <td>{{waybillPayload.securityStamp ? waybillPayload.securityStamp : '-'}}</td>
            </tr>
            <tr>
              <th>Required documents</th>
              <td>{{waybillPayload.requiredDocs ? waybillPayload.requiredDocs : '-'}}</td>
            </tr>
            <tr>
              <th>Waybill instructions</th>
              <td>{{waybillPayload.waybillInstructions ? waybillPayload.waybillInstructions : '-'}}</td>
            </tr>
            <tr>
              <th>Instruction code</th>
              <td>{{waybillPayload.instructionCode ? waybillPayload.instructionCode : '-'}}</td>
            </tr>
            <tr>
              <th>Secure delivery</th>
              <td>{{isSecureDelivery  ? isSecureDelivery : '-'}}</td>
            </tr>
            <tr>
              <th>Verification numbers</th>
              <td>{{waybillPayload.verificationNumbers ? waybillPayload.verificationNumbers : '-'}}</td>
            </tr>
            <tr>
              <th>Generate secure PIN</th>
              <td>{{generateSecurePIN ? generateSecurePIN : '-'}}</td>
            </tr>
            <tr>
              <th>Collection number</th>
              <td>{{waybillPayload.collectionNo ? waybillPayload.collectionNo : '-'}}</td>
            </tr>
            <tr>
              <th>Documents</th>
              <td>{{waybillPayload.documents ? waybillPayload.documents : '-'}}</td>
            </tr>
            <tr>
              <th>Complete waybill after save</th>
              <td>{{completeWaybillAfterSave ? completeWaybillAfterSave : '-'}}</td>
            </tr>
            <tr>
              <th>Booked date</th>
              <td>{{bookedDate ? bookedDate : '-'}}</td>
            </tr>
            <tr>
              <th>Sundry charges</th>
              <td>
                <ul>
                  @for (sundryCharge of waybillPayload.SundryCharges; track sundryCharge) {
                    <li>
                      {{getSundryChargeName(sundryCharge)}}
                    </li>
                  }
                </ul>
              </td>
            </tr>
          </table>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <div class="my-2">
      <core-parcel-list [parcels]="waybillPayload.parcels"></core-parcel-list>
    </div>
  </div>
}


